import { render } from "./RecoverPasswordModal.vue?vue&type=template&id=59c56204&scoped=true"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js"

import "./RecoverPasswordModal.vue?vue&type=style&index=0&id=59c56204&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c56204"]])

export default __exports__